import React from 'react'
import CCLButton from "./head/CCLButton"
import {useDispatch, useSelector} from "react-redux"
import {changeCCL} from "../../../actions/post"

export default function PublishLayerHeader() {
  const post = useSelector(state => state.post.newPost)
  const postType = Config.postType
  const dispatch = useDispatch()
  function handleChangeCCL(cclCommercial, cclDerive) {
    dispatch(changeCCL(cclCommercial, cclDerive))
  }

  return (
    <div className="layer_head">
      <strong className="tit_layer">발행</strong>
      {postType === 'post' &&
        <CCLButton
          cclDerive={post.cclDerive}
          cclCommercial={post.cclCommercial}
          onChange={handleChangeCCL}
        />
      }
    </div>
  )
}
